// Footer.tsx
import styled from "styled-components";
import localization from "../services/localization";

const FooterWrapper = styled.div`
  background-color: #000c0d;
  color: #fff;
  padding: 10px;
  text-align: center;
  height: auto;
  /* border: 2px solid red;
  border-color: #fff; */
  margin-top: 32px;
`;

// Styled component for the list
const StyledList = styled.ul`
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  @media (min-width: 768px) {
    gap: 20px;
  }
`;

// Styled component for the list items
const StyledListItem = styled.li`
  a {
    text-decoration: none;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #cccccc;

    &:hover {
      color: #ffffff;
    }
  }
`;

const SocialList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  @media (min-width: 768px) {
    gap: 20px;
  }
`;

// put near SocialListItem etc.
const Badge = styled.span`
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #00E676;   /* Channel = green */
  color: #0A0A0A;
  font: 700 10px/16px system-ui, sans-serif;
  text-align: center;
  box-shadow: 0 0 0 2px rgba(15,11,26,.9);
`;

const GroupBadge = styled(Badge)`
  background: #FF5252;   /* Group = red */
  color: #fff;
`;


// styled-components
const SocialListItem = styled.li`
  display: flex;
  gap: 10px;

  a {
    display: inline-flex;
    position: relative;      /* <-- add this */
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
      object-fit: contain;
      border-radius: 50%;
      transition: filter 0.3s;
    }

    &:not([aria-disabled="true"]) img:hover {
      filter: brightness(1.2);
    }

    &[aria-disabled="true"] {
      pointer-events: none;
      cursor: not-allowed;
    }
    &[aria-disabled="true"] img {
      filter: grayscale(1) opacity(0.4);
    }
  }
`;

const PaymentList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  padding: 0;
  mix-blend-mode: luminosity;

  @media (min-width: 768px) {
    gap: 96px;
  }

`;

const PaymentMethodLogo = styled.img`
  width: 95.2px;
  height: 24px;
  flex-grow: 0;
  object-fit: contain;
`;

const WeChatPayLogo = styled.img`
  width: 81.4px;
  height: 24px;
  flex-grow: 0;
  object-fit: contain;
`;

const PayPalLogo = styled.img`
  width: 90.5px;
  height: 24px;
  flex-grow: 0;
  object-fit: contain;
`;


const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <SocialList>
        <SocialListItem>
          {/* https://x.com/boxchaos88 
          https://x.com/voidpandacoin
          */}
          <a href="https://x.com/boxchaos88" target="_blank" rel="noopener noreferrer" title="X / Twitter">
            <img src="/assets/twitter.png" srcSet="/assets/twitter@2x.png 2x, /assets/twitter@3x.png 3x" alt="Twitter" />
          </a>
        </SocialListItem>

        <SocialListItem>
          <a
            href="https://youtube.com/@voidpandacoin"
            target="_blank" rel="noopener noreferrer"
            title="YouTube"
          >
            <img src="/assets/youtube.png" srcSet="/assets/youtube@2x.png 2x, /assets/youtube@3x.png 3x" alt="YouTube" />
          </a>
        </SocialListItem>

        <SocialListItem>
          <a
            href="https://t.me/voidpandacoin"
            target="_blank"
            rel="noopener noreferrer"
            title="Telegram Channel"
            aria-label="Telegram Channel"
          >
            <img src="/assets/svg/telegram.svg" alt="Telegram Channel" />
            <Badge aria-hidden="true">C</Badge>
          </a>
        </SocialListItem>

        <SocialListItem>
          <a
            href="https://t.me/voidpandacoin_group"
            target="_blank"
            rel="noopener noreferrer"
            title="Telegram Group"
            aria-label="Telegram Group"
          >
            <img src="/assets/svg/telegram.svg" alt="Telegram Group" />
            <GroupBadge aria-hidden="true">G</GroupBadge>
          </a>
        </SocialListItem>


        <SocialListItem>
          <a
            href="https://discord.gg/4GhgQ6nfap"
            target="_blank" rel="noopener noreferrer"
            title="Discord"
          >
            <img src="/assets/svg/discord.svg" alt="Discord" />
          </a>
        </SocialListItem>

        <SocialListItem>

          {/* https://www.tiktok.com/@boxchaos8
          https://www.tiktok.com/@voidpandacoin
          */}
          <a href="https://www.tiktok.com/@boxchaos8" target="_blank" rel="noopener noreferrer" title="TikTok">
            <img src="/assets/tik-tok.png" srcSet="/assets/tik-tok@2x.png 2x, /assets/tik-tok@3x.png 3x" alt="TikTok" />
          </a>
        </SocialListItem>
      </SocialList>


      <StyledList>
        {/* <StyledListItem>
          <a href="/">{localization.contacts}</a>
        </StyledListItem> */}
        <StyledListItem>
          <a href="/how-it-works">{localization.how_it_works}</a>
        </StyledListItem>
        <StyledListItem>
          <a href="/terms-of-service">{localization.term_of_service}</a>
        </StyledListItem>
        <StyledListItem>
          <a href="/privacy-policy">{localization.privacy_statement}</a>
        </StyledListItem>
        {/* <StyledListItem>
          <a href="/">{localization.provably_fair}</a>
        </StyledListItem> */}
        <StyledListItem>
          <a href="/support">{localization.support}</a>
        </StyledListItem>
        {/* <StyledListItem>
          <a href="/">{localization.partnership}</a>
        </StyledListItem> */}
        <StyledListItem>
          <a href="/cookie-policy">{localization.cookies_policy}</a>
        </StyledListItem>
        {/* <StyledListItem>
          <a href="/">{localization.aml_policy}</a>
        </StyledListItem> */}
      </StyledList>

      {/* <PaymentList>
      <a href="/" target="_blank">
        <PaymentMethodLogo
          src="/assets/alipay.png"
          srcSet="/assets/alipay@2x.png 2x, /assets/alipay@3x.png 3x"
          alt="Alipay Logo"
        />
      </a>
      <a href="/" target="_blank">
        <WeChatPayLogo
          src="/assets/we-chat-pay.png"
          srcSet="/assets/we-chat-pay@2x.png 2x, /assets/we-chat-pay@3x.png 3x"
          alt="WeChat Pay Logo"
        />
      </a>
      <a href="/" target="_blank">
        <PayPalLogo
          src="/assets/paypal.png"
          srcSet="/assets/paypal@2x.png 2x, /assets/paypal@3x.png 3x"
          alt="PayPal Logo"
        />
      </a>
    </PaymentList> */}

    </FooterWrapper>
  );
};

export default Footer;
